export function getIapResultUserMessage() {
  return "Purchases are unavailable in the web prototype.";
}
